import Costs from '../costs/costs';
export default function CostsTab(props) {

    const projectId = props.projectId
return (
    <div>
        <Costs isInProject = {true} projectId = {projectId}></Costs>
    </div>
)};